import { render, staticRenderFns } from "./orderAccessories.vue?vue&type=template&id=c19d7f9e&"
import script from "./orderAccessories.vue?vue&type=script&lang=js&"
export * from "./orderAccessories.vue?vue&type=script&lang=js&"
import style0 from "./orderAccessories.vue?vue&type=style&index=0&id=c19d7f9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports